import {
  useMutation,
  type MutationState,
} from 'src/core/api/hooks/useMutation';

import { type IntegrationStatus } from '../../../integration/status';

export const useChooseTenantMutation = (): MutationState<{
  tenantId: string;
}> => {
  return useMutation<{
    tenantId: string;
  }>({
    request: {
      type: 'rest',
      method: 'post',
      target: 'companyAPI',
      endpoint: '/accounting-integration/oauth2/choose-tenant',
    },
    options: {
      throwOnError: true,
      async onMutate({ payload, client }): Promise<void> {
        client.cancelQueries('useIntegrationStatusQuery');

        const currentStatus = client.getQueryData<IntegrationStatus>(
          'useIntegrationStatusQuery',
        );

        if (
          !currentStatus ||
          currentStatus.integration === 'noIntegration' ||
          currentStatus.integration === 'switchInProgress'
        ) {
          return;
        }

        if (
          currentStatus.authorization.kind !== 'oauth2OpenId' &&
          currentStatus.authorization.kind !== 'oauth2ScopedOpenId'
        ) {
          return;
        }

        client.setQueryData<IntegrationStatus>('useIntegrationStatusQuery', {
          ...currentStatus,
          authorization: {
            ...currentStatus.authorization,
            status: {
              status: 'connected',
              tenant: {
                type: 'organisation',
                // ideally the mutation should take the name and fill it here
                // (and not send it to the backend), but there is no way to
                // customize the payload of the request with our wrapper
                name: '',
                externalId: payload.tenantId,
              },
            },
          },
        });
      },
      onSuccess({ client }): void {
        client.invalidateQueries(['useIntegrationStatusQuery']);
      },
    },
  });
};
